import { ProgramHeaderItem } from "../types";
import { getResolvedPath } from "shared/utils";
import { MyExpRoute } from "apps/myExperience/routes/types";
import ProgramHeaderBehaviour from "./programHeaderBehaviour";
import TradeProgramStatus from "shared/enums/TradeProgramStatus";
import BuyersProgramStatus from "shared/enums/BuyersProgramStatus";
import MeetupProgramStatus from "shared/enums/MeetupProgramStatus";
import TabletalkProgramStatus from "shared/enums/TabletalkProgramStatus";
import AssociatedProgramStatus from "shared/enums/AssociateProgramStatus";
import InPersonMeetupProgramStatus from "shared/enums/InPersonMeetupProgramStatus";

export class MyExperienceBehaviour extends ProgramHeaderBehaviour {
  getInPersonMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<InPersonMeetupProgramStatus>> {
    return [];
  }

  getBuyersProgramStatusHeaderList(): Array<ProgramHeaderItem<BuyersProgramStatus>> {
    return [];
  }

  getMeetupProgramStatusHeaderList(): Array<ProgramHeaderItem<MeetupProgramStatus>> {
    return [];
  }

  getTradeProgramStatusHeaderList(): Array<ProgramHeaderItem<TradeProgramStatus>> {
    return [];
  }

  getTabletalkProgramStatusHeaderList(): Array<ProgramHeaderItem<TabletalkProgramStatus>> {
    return [];
  }

  getAssociatedProgramStatusHeaderList(
    currentProgramStage: AssociatedProgramStatus,
    programParticipantId?: string
  ): Array<ProgramHeaderItem<AssociatedProgramStatus>> {
    return [
      {
        displayOrder: 1,
        stagesIncluded: [AssociatedProgramStatus.ACTIVITY_PROFILE, AssociatedProgramStatus.SELECTION],
        labelKey: "program.header.activity.profile",
        path: `${getResolvedPath(MyExpRoute.WORKFLOW.path, {
          programParticipantId
        })}/${MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_ACTIVITIES.path}`
      },
      {
        displayOrder: 2,
        stagesIncluded: [AssociatedProgramStatus.SHORTLIST],
        labelKey: "program.header.shortlist",
        path: `${getResolvedPath(MyExpRoute.WORKFLOW.path, {
          programParticipantId
        })}/${MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_SHORTLIST.path}`,
        enabled: [AssociatedProgramStatus.SHORTLIST].includes(currentProgramStage)
      },
      {
        displayOrder: 3,
        stagesIncluded: [AssociatedProgramStatus.ACTIVITY_MATCHING, AssociatedProgramStatus.ACCEPT_ACTIVITY_SCHEDULE],
        labelKey: "program.header.accept.activity.schedule",
        path: `${getResolvedPath(MyExpRoute.WORKFLOW.path, {
          programParticipantId
        })}/${MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_SCHEDULE.path}`,
        enabled: [AssociatedProgramStatus.ACTIVITY_MATCHING, AssociatedProgramStatus.ACCEPT_ACTIVITY_SCHEDULE].includes(
          currentProgramStage
        )
      },

      {
        displayOrder: 4,
        stagesIncluded: [
          AssociatedProgramStatus.INVITES_SENT,
          AssociatedProgramStatus.IN_PROGRESS,
          AssociatedProgramStatus.RECONCILIATION,
          AssociatedProgramStatus.FEEDBACK
        ],
        labelKey: "program.header.invites.sent.associated.program",
        path: `${getResolvedPath(MyExpRoute.WORKFLOW.path, {
          programParticipantId
        })}/${MyExpRoute.WORKFLOW.ASSOCIATED_PROGRAM_MARK_ATTENDANCE.path}`,
        enabled: [
          AssociatedProgramStatus.INVITES_SENT,
          AssociatedProgramStatus.IN_PROGRESS,
          AssociatedProgramStatus.RECONCILIATION,
          AssociatedProgramStatus.FEEDBACK
        ].includes(currentProgramStage)
      }
    ];
  }
}
